<span  ngForm #frm="ngForm">
<label [ngClass]="labelClass" *ngIf="label">{{ label }}<span *ngIf="required">*</span></label>
<mat-radio-group [ngClass]="groupClass"
                 [(ngModel)]="result" (ngModelChange)="setValue($event)" name="{{ name}}"
     [appCustomPatternValidator]="fieldValidationConstraints" #control="ngModel">
  <mat-radio-button [color]="color" [ngClass]="elementClass" *ngFor="let option of options" [value]="getValue(option, value)"
                    [disabled]="disabled" (change)="onChange()">
    {{ getValue(option, display) !== undefined ? getValue(option, display) : getValue(option, value)}}
    <i *ngIf="option.icon" class="{{option.icon}}"></i>
    <app-custom-tooltip *ngIf="option.tooltip" type="INFO" position="after" [tooltips]="tooltips" [key]="option.tooltip" class="tooltip"></app-custom-tooltip>
  </mat-radio-button>
    <mat-error *ngIf="error && control.invalid && (control.touched || control.dirty) ">
      <ng-container *ngIf="control.errors?.regexp">
        {{ control.errors.regexp }}
      </ng-container>
      <ng-container *ngIf="!control.errors?.regexp">
        {{ error }}
      </ng-container>
    </mat-error>
</mat-radio-group>
</span>
